import { ReactQueryKeysAccount } from "services/queryKeys";

export const shouldInvalidateSupportAgent = (queryKey: unknown) => {
  return [
    ReactQueryKeysAccount.supportAccess,
    ReactQueryKeysAccount.supportAccessShort,
  ].includes(queryKey as ReactQueryKeysAccount);
};
